"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ImageWithText() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return;
}